import { BOOLEAN_FLAGS } from "@/lib/boolean/boolean-flags-constants";
import { CliError } from "@/lib/cli/cli-error";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export function parseFlag(
  argv: string[],
  index: number,
  parsed: ParsedArgs,
): number {
  const token = argv[index];
  if (token === undefined) {
    return index;
  }

  const withoutDashes = token.slice(2);
  const equalsAt = withoutDashes.indexOf("=");
  let name: string;
  let value: string | undefined;

  if (equalsAt >= 0) {
    name = withoutDashes.slice(0, equalsAt);
    value = withoutDashes.slice(equalsAt + 1);
    // `--json=false` must not become a truthy boolean flag.
    if (BOOLEAN_FLAGS.has(name)) {
      throw new CliError(
        `--${name} is a boolean flag: pass --${name} to enable it, or omit it. "--${name}=${value}" is not a value.`,
        2,
      );
    }
  } else {
    name = withoutDashes;
    const next = argv[index + 1];
    if (
      !BOOLEAN_FLAGS.has(name) &&
      next !== undefined &&
      !next.startsWith("--")
    ) {
      value = next;
      index += 1;
    }
  }

  // Empty value flags are typos; accepting `--url=` can select another target.
  if (value === undefined || value.trim() === "") {
    if (!BOOLEAN_FLAGS.has(name)) {
      throw new CliError(`--${name} expects a value.`, 2);
    }
    parsed.booleans.add(name);
    return index;
  }

  parsed.flags[name] = value;
  (parsed.repeated[name] ??= []).push(value);
  return index;
}
